import { Box, FlexBox } from '@dixa/lib-shared-habla';

import sidebarStyles from '../collectionSidebar/sidebar.module.scss';
import placeholderStyles from './placeholders.module.scss';

export function CollectionSidebarPlaceholder(): JSX.Element {
  const placeholder = placeholderStyles.placeholder;
  const IconAndBar = () => (
    <FlexBox gap="16px" alignItems={'center'} padding="8px 16px">
      <Box height="16px" width="16px" className={placeholder} />
      <Box height="14px" width="120px" className={placeholder} />
    </FlexBox>
  );

  return (
    <FlexBox className={sidebarStyles.sidebar}>
      <Box>
        <IconAndBar />
        <FlexBox padding="10px 16px">
          <Box height="12px" width="80px" className={placeholder} />
        </FlexBox>
        <IconAndBar />
        <IconAndBar />
        <IconAndBar />
        <IconAndBar />
      </Box>
      <Box>
        <IconAndBar />
      </Box>
    </FlexBox>
  );
}
